import React from 'react';
import Link from 'gatsby-link';

import ServiceBlock from '../ServiceBlock';

class TopNav extends React.Component {
  constructor(props, context) {
    super(props, context)

    this.items = props.items
    this.logo = props.logo
    this.location = props.location
    this.siteUrl = props.siteUrl

    this.state = {
      collapsed: true
    }
  }

  navigationItem(item) {
    item.object_slug = (item.object_slug == 'home') ? "" : item.object_slug

    let isActive = (this.location.pathname == "/" + item.object_slug)
    let itemcss = (isActive) ? "active " : ""

    const itempath = item.object_slug == '' ? '/' : `/${item.object_slug}/`

    if (item.object_slug == "") {
      itemcss =  `${itemcss} nav-item text-center col-md-4 d-none d-lg-block`

      return (
        <li className={itemcss} key={`${item.wordpress_id}`}>
          <Link to={itempath}>
            <img src={this.logo} className="img-fluid logo" alt="Grondwerken Jeroen Dierckx" />
          </Link>
        </li>
      )
    }
    else {
      itemcss = `${itemcss} nav-item text-center col-md-2`

      return (
        <li className={itemcss} key={`${item.wordpress_id}`}>
          <Link to={itempath} className="nav-link">
            {item.title}
          </Link>
        </li>
      )
    }
  }

  onToggleNav(e) {
    const state = this.state
    state.collapsed = (state.collapsed) ? false : true
    this.setState(state)

    if (e) e.preventDefault();
    return false;
  }

  render() {
    return (
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark bg-blue fixed-top">
        <Link to={`/`} className="navbar-brand d-lg-none w-75">
          <img src={this.logo} className="img-fluid logo" alt="Grondwerken Jeroen Dierckx" />
        </Link>

        <button className={`navbar-toggler ${this.state.collapsed && 'collapsed'}`} type="button" data-toggle="collapse" data-target="#topnav" onClick={(e) => this.onToggleNav(e)}>
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className={`collapse navbar-collapse ${!this.state.collapsed && 'show'}`} id="topnav">
          <ul className="navbar-nav w-100">
          {this.items.map(item => (
            this.navigationItem(item)
          ))}
          </ul>
        </div>
      </nav>
    )
  }
}

export default TopNav;



// WEBPACK FOOTER //
// ./src/components/TopNav/index.jsx